import React, {useMemo} from 'react';
import { Collapse, Typography } from 'antd';

const { Panel } = Collapse;
const { Text } = Typography;

const SingleCollapsePanel = ({header, defaultOpen, className, children}) => {

    const panelHeader = useMemo(() => {
        if(typeof header === 'string'){
            return (
                <Text className="text-bold">{header}</Text>
            );
        }
        return header;
    },[header]);
    
    return(
        <Collapse defaultActiveKey={defaultOpen ? ["panel"] : undefined} className={className}>
            <Panel header={panelHeader} key={"panel"}>
                {children}
            </Panel>
        </Collapse>
    );
}

export default SingleCollapsePanel;